import React from "react";

export default function ProficiencyLevels_KH_EN() {
  return (
    <>
      <h2>Proficiency levels explained</h2>
      <div>
        To better understand your personal competence profile, you should look at your performance by
        area. It should give you a first idea that can help you determine your relative weaknesses and
        strengths, while providing you with suggestions and ideas to further develop your digital
        practices.
        <ul>
          <li>A Level: 0/96 points, 0%</li>
          <li>B Level: up to 32/96 points, up to 33%</li>
          <li>C Level: 33-64/96 points, 34-67%</li>
          <li>D Level: 65-96/96 points 68-100%</li>
        </ul>
      </div>
      <div>
        <h3>A Level: Digital Uninitiated</h3>
        <div style={{ marginBottom: "20px" }}>
          You are at the very beginning of your digital journey in education. Perhaps the vast world of
          digital tools and techniques feels unfamiliar and a tad overwhelming. While you might not have
          explored or employed many (if any) digital strategies in your teaching yet, you possess a
          genuine curiosity and willingness to learn. As you embark on this journey, remember that
          everyone starts somewhere. With the right resources and support, you'll soon find your footing,
          discovering the endless possibilities that digital integration offers to enhance your teaching.
        </div>
      </div>
      <div>
        <h3>B Level: Digital Novice </h3>
        <div style={{ marginBottom: "20px" }}>
          You've might have tried a few digital tools, and you're thinking about how to integrate them
          more consistently. As you delve deeper, you're eager to understand the myriad ways these tools
          can augment your teaching strategies, leading you to explore and experiment in different
          contexts.
        </div>
      </div>
      <div>
        <h3>C Level: Digital Practitioner</h3>
        <div style={{ marginBottom: "20px" }}>
          You've moved beyond the basics and are integrating digital technologies into your daily
          practices. Your toolbox of digital strategies is expanding, and you're mastering the art of
          choosing the right tool for each situation. You're seeing both the strengths and weaknesses of
          various digital approaches. By experimenting and reflecting continuously, you're fine-tuning
          your methods. And as your expertise grows, you find yourself sharing insights and guiding your
          peers on their digital journeys.
        </div>
      </div>
      <div>
        <h3>D Level: Digital Innovator</h3>
        <div style={{ marginBottom: "20px" }}>
          You stand at the forefront of digital innovation in education. Your approach to using digital
          technologies is both broad and deep, allowing you to select the best strategies consistently.
          You're not just a user; you're a leader, setting trends and assisting others on their paths.
          You continuously update yourself with the latest in digital innovations and are pushing the
          boundaries in your quest to innovate further. While you're a role model in your community, you
          remain open and receptive to new ideas, ensuring that you're always ready to take the next
          innovative step.
        </div>
      </div>
    </>
  );
}
